import React from "react";
import Particles from "react-tsparticles";
import { Link } from "react-router-dom";
import Social from "../Social";

const ThankYouHero = () => {
  return (
    <section
      className="home-banner home-banner-two thankyou-hero"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + "img/slider/home-banner-3.jpg"})`,
        transform: "scaleX(-1)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right center",
        backgroundSize: "auto 80%",
      }}
    >
      <div className="frame-layout__particles">
        <Particles
          id="tsparticles"
          options={{
            backgroundMode: { enable: true, zIndex: 1 },
            fullScreen: { enable: false, zIndex: -1 },
            fpsLimit: 70,
            interactivity: {
              detectsOn: "canvas",
              events: { onClick: { enable: false }, onHover: { enable: false }, resize: true },
            },
            particles: {
              color: { value: "#ddd" },
              links: { color: "#ffffff", distance: 150, enable: true, opacity: 0.5, width: 1 },
              collisions: { enable: true },
              move: { enable: true, speed: 2 },
              number: { density: { enable: true, value_area: 800 }, value: 30 },
              opacity: { value: 0.5 },
              shape: { type: "circle" },
              size: { random: true, value: 6 },
            },
            detectRetina: true,
          }}
        />
      </div>

      <div className="container" style={{ transform: "scaleX(-1)" }}>
        <div className="row full-screen align-items-center">
          <div className="col-lg-12">
            <div className="type-box text-right ml-auto" style={{ maxWidth: 720 }}>
              <h6 data-aos="fade-up" data-aos-duration="1200" style={{ color: "#e6e6e6" }}>Thanks for reaching out</h6>
              <h1 className="font-alt" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100" style={{ color: "#e6e6e6" }}>
                I’ll be in touch soon
              </h1>
              <p className="desc" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300" style={{ color: "#e6e6e6" }}>
                In the meantime, feel free to explore more of my work or connect with me on social.
              </p>
              <div className="mt-4" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="400">
                <Link className="px-btn px-btn-theme2 m-10px-r" to="/" style={{ color: "#000" }}>Back to the website</Link>
              </div>
              <div className="thankyou-social" style={{ marginTop: 25 }}>
                <Social />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThankYouHero;


